import lazyLoading from "./lazyLoading";

export default {
  name: "ljekari",
  path: "/ljekari",
  component: lazyLoading("ljekari/Ljekari"),
  meta: {
    default: false,
    title: "Ljekari",
    class: "primary",
    show: false,
    iconClass: "fa fa-user-md",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/ljekari.js